/** `@react-native-async-storage/async-storage` → localStorage (zustand persist dos stores). */
const PREFIX = 'kontto-web:async:';
const AsyncStorage = {
  async getItem(key: string): Promise<string | null> { return localStorage.getItem(PREFIX + key); },
  async setItem(key: string, value: string): Promise<void> { localStorage.setItem(PREFIX + key, value); },
  async removeItem(key: string): Promise<void> { localStorage.removeItem(PREFIX + key); },
  async multiRemove(keys: string[]): Promise<void> { keys.forEach((k) => localStorage.removeItem(PREFIX + k)); },
  async getAllKeys(): Promise<string[]> {
    return Object.keys(localStorage).filter((k) => k.startsWith(PREFIX)).map((k) => k.slice(PREFIX.length));
  },
  async clear(): Promise<void> { (await this.getAllKeys()).forEach((k) => localStorage.removeItem(PREFIX + k)); },
};
export default AsyncStorage;
